import { render, staticRenderFns } from "./competitors.vue?vue&type=template&id=502cce87&"
import script from "./competitors.ts?vue&type=script&lang=ts&"
export * from "./competitors.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports